(() => {
  const GetCart = () => {
    return fetch('/cart.js').then(res => res.json());
  }

  const AddItemsToCart = (itemsToAdd) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
    .then(res => res.json());
  }

  const RemoveItemFromCart = (itemToRemove) => {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemToRemove)
    })
    .then(res => res.json());
  }

  const RushProcessing = () => {
    document.querySelectorAll('.row-rush-processing').forEach(($section) => {
      $section.addEventListener('change', async (e) => {
        //console.log(e);
        let $target = e.target;
        let isCheckbox = $target.type == 'checkbox';
        if (isCheckbox) {
          // add processing item to cart
          let addProcessing = $target.checked;
          if (addProcessing) {
            let itemsToAdd = [
              {
                id: $target.dataset.variant,
                quantity: 1,
                properties: {
                  '_priority-processing': true
                }
              }
            ]
            let resp_add = await AddItemsToCart(itemsToAdd);
            $target.dataset.key = resp_add.items[0].key;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          }
          else {
            // remove processing item from cart
            let lineItemKey = $target.dataset.key;
            let resp_remove = await RemoveItemFromCart({ id: lineItemKey, quantity: 0 });
            $target.dataset.key = null;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          }
        }
      });
    });
  }

  const HeaderSearchClose = () => {
    let $btnCloseSearch = document.querySelector('.site-header__search-btn--cancel');
    if (!$btnCloseSearch) return;

    $btnCloseSearch.addEventListener('click', (e) => {
      let $form = $btnCloseSearch.closest('form');
      $form.querySelector('[name=q]').value = '';
    });
  }

  const HeaderMobileLinks = () => {
    document.querySelectorAll('.slide-nav__button[data-url]').forEach(($item) => {
      $item.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = $item.dataset.url;
      });
    });
  }

  const DOMReady = () => {
    console.log('READY');
    RushProcessing();
    HeaderSearchClose();
    HeaderMobileLinks();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();